import React, { useEffect, useState } from "react";
import "./thankYouForOrder.scss";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import KristiveLogo from "../../assets/kristive.svg";
import ThankYouImg from "../../assets/img/thank-you.webp";
import paymentStore from "../../store/paymentStore";
import { formatDate } from "../../utils/helper.js";
import { Skeleton } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import orderStore from "store/orderStore";
import MyLoader from "components/myLoader/MyLoader";

const ThankYouForOrder = () => {
  const year = new Date().getFullYear();
  const PaymentStore = paymentStore();
  const navigate = useNavigate();
  const OrderStore = orderStore();
  const [id, setId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [paymentDetail, setPaymentDetail] = useState(null);

  useEffect(() => {
    const getId = async () => {
      const id = await OrderStore.getOrderId();
      if (id) {
        setId(id);
      } else {
        navigate("/");
      }
    };
    getId();
  }, []);

  useEffect(() => {
    if (!id) return;
    init();
  }, [id]);

  const init = async () => {
    setIsLoading(true);
    const response = await PaymentStore.getPaymentWithOrderDetails({
      id: id,
    });
    if (response) {
      setPaymentDetail(response.paymentDetail);
    } else {
      navigate("/");
    }
    setIsLoading(false);
  };

  if (!id)
    return (
      <div className="thank-you-for-order">
        <MyLoader height="100vh" />
      </div>
    );

  return (
    <div className="thank-you-for-order">
      <header className="site-header">
        <a className="site-header__logo-link" href="/">
          <img
            src={KristiveLogo}
            alt="brand-logo"
            style={{ height: "80px", width: "80px" }}
          />
        </a>
      </header>

      <main className="order-page">
        <section className="order-hero">
          <span className="order-hero__eyebrow">Order Confirmed</span>

          <h1 className="order-hero__title">Thank you for your order.</h1>

          <p className="order-hero__description">
            Your selection has been received. Our artisans are now preparing
            your order with the utmost care.
            {/* A confirmation email has been sent to your address. */}
          </p>
        </section>

        <section className="order-details">
          <div className="order-details__image">
            <img
              src={ThankYouImg}
              alt="A highly detailed, cinematic photograph of a luxurious Kristive perfume gift box resting on a pristine marble surface. The box is an elegant cream color tied with a pristine satin ribbon. Soft, diffused natural light filters in, highlighting the subtle textures of the packaging and creating a calm, high-end editorial mood in a minimalist luxury setting."
            />
          </div>

          <div className="order-details__content">
            <div className="order-summary">
              <h2 className="order-summary__title">Order Summary</h2>

              <div className="order-summary__grid">
                <div className="order-summary__label">Order Number</div>

                {isLoading ? (
                  <Skeleton width="100%" animation="wave">
                    <p>Demo</p>
                  </Skeleton>
                ) : (
                  <div className="order-summary__value">
                    #{paymentDetail?._id}
                  </div>
                )}

                <div className="order-summary__label">Date</div>

                {isLoading ? (
                  <Skeleton width="100%" animation="wave">
                    <p>Demo</p>
                  </Skeleton>
                ) : (
                  <div className="order-summary__value">
                    {formatDate(paymentDetail?.payment_at, "MMMM DD, YYYY")}
                  </div>
                )}

                <div className="order-summary__label">Total</div>

                {isLoading ? (
                  <Skeleton width="100%" animation="wave">
                    <p>Demo</p>
                  </Skeleton>
                ) : (
                  <div className="order-summary__value">
                    ₹{paymentDetail?.total}
                  </div>
                )}
              </div>
            </div>

            <div className="order-information">
              <div className="order-information__item">
                <LocalShippingRoundedIcon className="icon order-information__icon" />

                <div>
                  <h3 className="order-information__title">
                    Delivery Estimation
                  </h3>

                  <p className="order-information__text">
                    Estimated delivery within 7 days
                  </p>
                </div>
              </div>

              <div className="order-information__item">
                <LocationOnRoundedIcon className="icon order-information__icon" />

                <div>
                  <h3 className="order-information__title">Shipping Address</h3>

                  <p className="order-information__text">
                    {isLoading ? (
                      <Skeleton width="100%" animation="wave">
                        <p>Demo</p>
                      </Skeleton>
                    ) : (
                      paymentDetail?.addressID?.fullName
                    )}
                    {!isLoading && <br />}
                    {isLoading ? (
                      <Skeleton width="100%" animation="wave">
                        <p>Demo</p>
                      </Skeleton>
                    ) : (
                      paymentDetail?.addressID?.address
                    )}
                    {!isLoading && <br />}
                    {isLoading ? (
                      <Skeleton width="100%" animation="wave">
                        <p>Demo</p>
                      </Skeleton>
                    ) : (
                      `${paymentDetail?.addressID?.city}, ${paymentDetail?.addressID?.state} - ${paymentDetail?.addressID?.pincode}`
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="return-to-home">
          <Link
            to="/"
            replace
            onClick={() => OrderStore.clearOrderId()}
            className="button button--primary"
          >
            Go To Home
          </Link>
        </section>
      </main>

      <footer className="site-footer">
        <div className="site-footer__content">
          <span className="site-footer__brand">KRISTIVE</span>
          <p className="site-footer__copyright">
            © {year} Kristive. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ThankYouForOrder;
